<!--The content below is only a placeholder and can be replaced.-->
<div class="o-search-app__content">
  <!-- Search input -->
  <cov-input-search (searchChange)="search($event)" [searchText]="searchText" [shouldFocus]="shouldFocus">
  </cov-input-search>

  <cov-loading-indicator *ngIf="isLoading()"></cov-loading-indicator>

  <ng-template [ngIf]="displayResults && !isLoading()">

    <ng-container *ngIf="hasContentResults() || hasProductResults() || hasErrors(); else noResults">

      <!-- results headings, x results found -->
      <cov-heading *ngIf="hasContentResults()" [level]="resultHeadingLevel" [modifier]="resultHeadingModifier"
        [text]="resultHeadingText" [class]="resultHeadingClass">
      </cov-heading>
      <cov-heading *ngIf="!hasContentResults() && hasProductResults()" [level]="productResultHeadingLevel"
        [modifier]="productResultHeadingModifier" [text]="productResultHeadingText" [class]="productResultHeadingClass">
      </cov-heading>

      <!-- tabs -->
      <cov-search-tabs [resultTabs]="searchResultTabs" (tabChange)="tabChange($event)"></cov-search-tabs>

      <!-- result list -->
      <ng-container *ngFor="let resultTab of searchResultTabs; index as index">

        <!-- products scroll -->
        <cov-loading-indicator *ngIf="resultTab.active && index == 0 && productScrollerLoading">
        </cov-loading-indicator>
        <cov-scrollable-teaser *ngIf="resultTab.active && index == 0 && hasProductResults()"
          [productScroller]="productScroller" [searchText]="searchText" [sortOrder]="productResultSortOrder">
        </cov-scrollable-teaser>

        <!-- results list -->
        <cov-search-result-list *ngIf="resultTab.active && !resultTab.error" [attr.data-active-tab]="index"
          [resultTab]="resultTab" [searchText]="searchText">
        </cov-search-result-list>

        <!-- bottom results heading -->
        <div class="o-search-app__list-count" *ngIf="resultTab.active && resultTab.totalCount > 0" [innerHTML]="bottomResultsHeading"></div>
        
        <!-- load more button -->
        <div class="o-search-app__button-wrapper" *ngIf="showLoadMoreButton() && resultTab.active && !resultTab.error">
          <cov-button *ngIf="!showLoadMoreSpinner" [text]="loadMoreText" [modifier]="loadMoreModifer"
            (click)="loadMoreResults()">
          </cov-button>
          <cov-loading-indicator *ngIf="showLoadMoreSpinner"></cov-loading-indicator>
        </div>

        <!-- teaser banners -->
        <ng-container *ngIf="resultTab.active">
          <ng-container *ngFor="let banner of resultTab.tab.teaserBanners">
            <cov-teaser-banner [bannerText]="banner.title" [defaultTheme]="banner.defaultTheme"
              [backgroundImage]="banner.backgroundImage" [buttonText]="banner.button"
              [buttonQueryString]="banner.buttonQueryString" [searchTxt]="searchText"
              [sortOrder]="productResultSortOrder" [description]="banner.description">
            </cov-teaser-banner>
          </ng-container>
        </ng-container>

        <!-- error message -->
        <cov-message-box [message]="errorMessage" [modifier]="'search'" *ngIf="resultTab.active && resultTab.error">
        </cov-message-box>

        <!-- Show "spacer-bottom" container when load more button is not visible -->
        <div *ngIf="resultTab.active && !showLoadMoreButton()" class="o-search-app__spacer-bottom"></div>

      </ng-container>

    </ng-container>

    <!-- no results found -->
    <ng-template #noResults>
      <cov-search-no-results [noResultsTitle]="noResultsTitle" [noResultsText]="noResultsText" [showButton]="false">
      </cov-search-no-results>

      <ng-container *ngFor="let banner of noResultTeaserBanners">
        <cov-teaser-banner [bannerText]="banner.title" [defaultTheme]="banner.defaultTheme"
          [backgroundImage]="banner.backgroundImage" [buttonText]="banner.button" [description]="banner.description">
        </cov-teaser-banner>
      </ng-container>
    </ng-template>

  </ng-template>

</div>